import { useEffect, useState } from "react";
import {
  Container,
  Dropdown,
  Nav,
  Navbar,
  NavDropdown,
  Placeholder,
  Table,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { HeadPage } from "src/componentes";
import { getLabel } from "src/hook/Functions";
import { IRoute } from "src/interfaces/IRoute";
import SistemaCode from "./Sistema.Code";
import { subModuloOptions } from "./Sistema.Dto";

const SistemaView = () => {
  const [menuItens, setMenuItens] = useState<IRoute[]>([]);
  const navigate = useNavigate();
  const { loading, data, handleSelect, filtros } = SistemaCode();

  useEffect(() => {
    setMenuItens([
      { name: "Nova Configuracao...", route: "/configuracao/sistema/cadastro" },
    ]);
  }, []);

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const handleClickPropriedades = (item: any) => () => {
    navigate(`/configuracao/sistema/cadastro?id=${item.id}`);
  };

  return (
    <Container>
      <HeadPage headText="Sistema Configuração">
        {menuItens !== undefined &&
          menuItens.map((item) => (
            <Dropdown.Item
              key={item.name}
              onClick={handleClickNavigate(item.route)}
            >
              {item.name}
            </Dropdown.Item>
          ))}
      </HeadPage>
      {!loading ? (
        <>
          <Navbar className="bg-body-tertiary justify-content-between">
            <Container>
              <Navbar.Collapse className="justify-content-end">
                <Nav className="ms-auto">
                  <NavDropdown
                    onSelect={handleSelect}
                    id="dropdown-subModulo"
                    title={getLabel(
                      subModuloOptions,
                      filtros.subModulo,
                      "Status Envio"
                    )}
                  >
                    {subModuloOptions.map((option) => (
                      <NavDropdown.Item
                        key={option.value}
                        eventKey={option.value}
                        active={filtros.subModulo === option.value}
                      >
                        {option.label}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>

          <Table responsive hover>
            <thead>
              <tr>
                <th className="col-2">Configuração</th>
                <th className="col-10">Valor</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr
                  key={item.id}
                  onClick={handleClickPropriedades(item)}
                  style={{ cursor: "pointer" }}
                >
                  <td className="col-2">{item.tipoConfiguracaoDescricao}</td>
                  <td className="col-10">{item.configuracaoValor}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <Placeholder animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      )}
    </Container>
  );
};
export default SistemaView;
